import { Agriculture, Badge, Dashboard, Delete, Edit, Forest, GppGood, Grass, Landscape, Map, MenuBook, Report, Search, Title } from "@mui/icons-material";
import { Button, Chip, Fab, Paper, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
import { Link } from "react-router-dom";
import { variables } from "../../styles/abstract/variables";
import WidgetDescription from "../widgets/WidgetDescription";

function ProjectBox({ project, onToggleReports, onToggleRemove, onToggleEdit, onSelectProject }) {
  return (
    <Paper component={Stack} justifyContent={"space-between"} elevation={3} sx={{ position: 'relative', padding: '10px', minHeight: '180px' }} className="co-background-white fade-in">
      <Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {/* <div style={{width: 64}}></div> */}
          <WidgetDescription text={project.getName()} style={{ fontWeight: 'bold' }} />
          {project.farmpactId && <Tooltip arrow title={<>
            <p>Approved by the FarmPact program</p>
            <p>Identifier: {project.farmpactId}</p>
          </>}><GppGood fontSize="large" color="success" />
          </Tooltip>}
        </Stack>
        <p title={project.getDescription()} className="co-text-opacity text-bold multiline-ellipsis">{project.getDescription()}</p>
      </Stack>

      <Stack sx={{ marginBottom: '50px' }} justifyContent="space-between" alignItems="center" direction="row" spacing={2}>
        <span className="co-text-opacity" style={{ fontSize: '13px', fontWeight: 'bold' }}>{project.getDate()}</span>
        {/* <Stack direction="row" alignItems="center" spacing={1}>
          {project.isAgroforestry ? <Forest color="primary" /> : <div style={{height: '24px'}}></div>}
          {project.isAgroforestry ? <strong className="co-text">Agroforestry</strong> : <div style={{height: '24px'}}></div>}
        </Stack> */}
      </Stack>



      <Stack direction="row" alignItems="center" justifyContent="center" style={{ position: 'absolute', bottom: '15px', width: 'calc(100% - 30px' }} sx={{'& button, & a': {fontSize: '12px !important'}, display: {xs: 'none', sm: 'flex'}}} spacing={1}>
        <Button variant="contained" onClick={onSelectProject} component={Link} to={`/dashboard/project/${project.getId()}/map/`} style={{ lineHeight: 'unset' }} startIcon={<Map fontSize="small" />} size="small" color="primary">MAP</Button>
        <Button variant="contained" onClick={onSelectProject} color="primary" component={Link} to={`/dashboard/project/${project.getId()}/carbon-management-system/`} style={{ lineHeight: 'unset' }} startIcon={<Dashboard fontSize="small" />} size="small">DASHBOARD</Button>
        {/* <Button onClick={() => onToggleReports({parcels: project.parcels})}style={{lineHeight: 'unset'}} startIcon={<MenuBook fontSize="small" />} size="small" color="primary">Reports</Button> */}
        <Button variant="contained" color="warning" onClick={() => onToggleEdit(project)} size="small" sx={{ lineHeight: 'unset' }} startIcon={<Edit />}>EDIT</Button>

        <Button onClick={() => onToggleRemove(project)} variant="contained" style={{ lineHeight: 'unset' }} startIcon={<Delete fontSize="small" />} size="small" color="error">Delete</Button>

      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="center" style={{ position: 'absolute', bottom: '15px', width: 'calc(100% - 30px' }} sx={{'& button, & a': {fontSize: '12px !important'}, display: {xs: 'flex', sm: 'none'}}} spacing={2}>
        <Fab variant="contained" onClick={onSelectProject} component={Link} to={`/dashboard/map/${project.getId()}`} style={{ lineHeight: 'unset' }} size="small" color="primary"><Map fontSize="small" /></Fab>
        <Fab variant="contained" onClick={() => {}} color="primary" component={Link} to="" style={{ lineHeight: 'unset' }} size="small"><Dashboard fontSize="small" /></Fab>
        {/* <Fab onClick={() => onToggleReports({parcels: project.parcels})}style={{lineHeight: 'unset'}} startIcon={<MenuBook fontSize="small" />} size="small" color="primary">Reports</Fab> */}
        <Fab variant="contained" color="warning" onClick={() => onToggleEdit(project)} size="small" sx={{ lineHeight: 'unset' }}><Edit /></Fab>

        <Fab onClick={() => onToggleRemove(project)} variant="contained" style={{ lineHeight: 'unset' }} size="small" color="error"><Delete fontSize="small" /></Fab>

      </Stack>

    </Paper>
  )
}

export default ProjectBox;